import React from 'react';
import { HeaderSecondary } from '@app/src/common/header';
import { StepContainer } from './components/StepContainer';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { useSelector } from 'react-redux';

interface Args {
  step?: number;
  alias?: string;
}

const hoc = (Component: React.FC<{}>, args?: Args) => () => {
  const categoryId = useSelector(state => state.print.general.category);
  const categoryConfig = CATEGORIES[CATEGORY[categoryId]];

  return(
  <React.Fragment>
    <HeaderSecondary
      itemActive={categoryConfig && categoryConfig.alias}
      ubicationSite={true}
      positionOf={args && [args.step, 4]}
    />
    <StepContainer alias={categoryConfig && categoryConfig.alias}>
      <Component />
    </StepContainer>
  </React.Fragment>
)};

export const withStep = hoc;
